import { render } from "./FullProcessRough.vue?vue&type=template&id=c9c942a8"
import script from "./FullProcessRough.vue?vue&type=script&lang=js"
export * from "./FullProcessRough.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__